import { apiClient, API_PRX } from '@indipia/shared';
import type { ApiResponse } from '@indipia/shared-types';

// ── POST /member/studio/agents/setup ────────────────────────────────────────
// 온보딩 초기 일괄 구독. 이미 구독 중인 agentId는 스킵.

export interface SetupResult {
  subscribedCount: number;
  agentSubIds: number[];
}

export async function setupAgents(agentIds: number[]): Promise<SetupResult> {
  const res = await apiClient.post<ApiResponse<SetupResult>>(
    `${API_PRX.MEMBER}/studio/agents/setup`,
    { agentIds },
  );
  return res.data.data;
}

// ── PATCH /member/studio/stage ───────────────────────────────────────────────

export async function updateStudioStage(studioStage: number): Promise<number> {
  const res = await apiClient.patch<ApiResponse<{ stage: number }>>(
    `${API_PRX.MEMBER}/studio/stage`,
    { studioStage },
  );
  return res.data.data.stage;
}

// ── PATCH /member/studio/completion ─────────────────────────────────────────
// 스튜디오 완성도 업데이트. FE가 최초 행위 여부 판단 후 호출.

export type CompletionActionCode = 'AGENT_SUB' | 'SITE_REG' | 'VENDOR_REG';
export type CompletionDirection  = 'UP' | 'DOWN';

export async function updateCompletion(
  actionCode: CompletionActionCode,
  direction: CompletionDirection,
): Promise<number> {
  const res = await apiClient.patch<ApiResponse<{ completion_rate: number }>>(
    `${API_PRX.MEMBER}/studio/completion`,
    { actionCode, direction },
  );
  return res.data.data.completion_rate;
}
